module.exports = __webpack_public_path__ + "img/caladan.c018183c.png";